<template>
    <div class="login-page">
        <div class="cover">
            <img class="w-100" src="@/assets/login/store.png" alt="">
        </div>
        <form @submit.prevent="login">
            <h2 class="section-title">
                <JaLogIn style="margin-left: 0.2rem;" />
                تسجيل <span>الدخول</span>
            </h2>
            <p>
                تقدر تسجل دخول برقم التلفون وكلمه المرور الخاصه بيك
            </p>
            <div class="input">
                <label for="">
                    <AnFilledPhone style="margin-left: 0.5rem;" />
                    رقم الهاتف
                </label>
                <input v-model="login_data.username" type="text" placeholder="رقم الهاتف">
            </div>
            <ErrorMsgComponent v-if="errors['username']" :message="errors['username'][0]" />
            <div class="input">
                <label for="">
                    <ReLockPasswordFill style="margin-left: 0.5rem;" />
                    كلمه المرور
                </label>
                <input v-model="login_data.password" type="password" placeholder="كلمه المرور">
            </div>
            <ErrorMsgComponent v-if="errors['username']" :message="errors['username'][0]" />

            <button type="submit" class="auth-btn" v-if="!is_loading">
                تسجيل الدخول
            </button>
            <button class="auth-btn" v-else disabled>
                <span class="spinner-border" ></span>
            </button>
        </form>
    </div>
</template>
<script>
import ErrorMsgComponent from '@/components/Error/ErrorMsgComponent.vue';
import config from '@/services/config';
import Validator from '@/services/Validator';
import { JaLogIn, AnFilledPhone, ReLockPasswordFill } from '@kalimahapps/vue-icons';
import axios from 'axios';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';

export default {
    name: 'LoginView',
    components: {
        JaLogIn,
        AnFilledPhone,
        ReLockPasswordFill ,
        ErrorMsgComponent
    },
    data() {
        return {
            login_data: {
                username: '',
                password: ''
            },
            errors: {},
            is_loading: false
        }
    },
    methods: {
        login() {
            this.errors = {}
            let validation = new Validator;

            // validation inputs 
            validation.setKey('username').setValue(this.login_data.username).required()
            validation.setKey('password').setValue(this.login_data.password).required()

            if (validation.haveError) {
                this.errors = { ...validation.getErrors() }
                return;
            }

            this.is_loading= true;

            axios.post(`${config.basURL}accounts/signin/`, this.login_data)
                .then(res => {

                    // add token to global state
                    this.$store.commit("LOGIN_USER", `Bearer ${res.data.access}`);
                    // save data to cookies
                    Cookies.set("user_token", `Bearer ${res.data.access}`, {
                        secure: true,
                        sameSite: "strict",
                        expires: 2, //expire in to days
                    });
                    Cookies.set("user_data", JSON.stringify(res.data), {
                        secure: true,
                        sameSite: "strict",
                        expires: 2, //expire in to days
                    });

                    Swal.fire({
                        toast: true,
                        text: " تم تسجيل الدخول بنجاح ",
                        icon: "success",
                        showConfirmButton: false,
                        timer: 1500,
                        timerProgressBar: true,
                        position: "top-end",
                    });

                    this.$router.push('/')

                }).catch(err => {

                    console.log(err);
                    if (err.response.status === 500) {
                        Swal.fire({
                            text: "حدث خطأ في الخادم برجاء المحاولة مرة أخرى",
                            icon: "error",
                        });
                    } else if (err.response.status === 400) {
                        Swal.fire({
                            text: "اسم المستخدم أو كلمة المرور غير صحيحة",
                            icon: "error",
                        });
                    } else if (err.response.status === 401) {
                        Swal.fire({
                            text: "هذا المستخدم غير موجود الرجاء التسجيل أولا",
                            icon: "error",
                        });
                    } else {
                        Swal.fire({
                            text: " حدث خطاء برجاء المحاوله مؤه اخري ",
                            icon: "error",
                        });
                    }

                }).finally(() => {
                    this.is_loading = false
                })
        }
    }
}
</script>
<style scoped>
.login-page {
    padding: 1.5rem 0;
    display: flex;
    justify-content: space-between;
    min-height: 100vh;
}

.login-page .cover {
    padding: 1rem;
    width: 35%;
    min-height: 100%;
    background-color: #B7E0FF;
}

.login-page form {
    width: 50%;
    padding: 0 1.5rem;
}

.input {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-bottom: 2px solid #B7E0FF;
    margin-bottom: 1.2rem;
}

.input input {
    all: unset;
    width: 100%;
    padding: 0.5rem;
    font-size: 1.2rem;
    position: relative;
    overflow: hidden;
}

.input input::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #B7E0FF;
    z-index: 2;
}

input::placeholder {
    color: #B7E0FF;
}

input:focus::placeholder {
    color: transparent
}

.auth-btn {
    all: unset;
    padding: 0.5rem 1.3rem;
    background-color: #FF9D23;
    color: #34495e;
    cursor: pointer;
    text-align: center;
    border-radius: 5px;
    transition: all 0.5s;
    font-size: 1.2rem;
}

.auth-btn:hover {
    background-color: #FFD65A;
}

@media(max-width: 767px) {
    .login-page .cover {
        display: none;
    }
    .login-page form  {
        width: 100%;
    }
}
</style>